import React from 'react';
import styled from 'styled-components';

import { getStatusColor, getStatusName } from './status';

const Badge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  background-color: ${(props) => props.$color};
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
`;

export default function StatusBadge({ status }) {
  return (
    <Badge
      $color={getStatusColor(status?.slug)}
      data-testid="status-badge"
      data-status={status?.slug}
    >
      {getStatusName(status)}
    </Badge>
  );
}
